<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    append-to-body
    :before-close="handleClose"
  >
    <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
      <div>修改文稿标题</div>
    </div>
    <div class="bj">
      <div style="width:100px;">文稿标题：</div>
      <el-input
        placeholder="请输入文稿标题"
        v-model="message.title">
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}" type="primary" @click="changeDesc">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: [
    'message',
    'dialogVisible',
  ],
  watch: {
    dialogVisible: {
      deep: true,
      handler(v) {
        this.dialogVisible = v;
      },
    },
  },
  data() {
    return {
      msg:''
    };
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    changeDesc(){
      this.$emit('changeDesc',this.message)
    }
  },
  created() {
    // this.msg = this.message
  },
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.bj{
  display: flex;
  align-items: center;
}
</style>